<p-dialog
  (visibleChange)="close()"
  [modal]="true"
  [closable]="!cancelDisabled()"
  [showHeader]="false"
  [visible]="isOpened()"
  class="dialog-primary headless w430 authenticator-dialog"
>
  <div class="dialog-body">
    <app-icon-alert-circle [height]="64" [width]="64"></app-icon-alert-circle>

    <div class="title text-18 fw-600">{{ 'users.authenticator.setup.title' | translate }}</div>
    <div class="description text-14 fw-400">
      {{ 'users.authenticator.setup.description' | translate }}
    </div>

    <ul class="steps">
      @for (step of [0, 1, 2]; track step; let i = $index) {
        <li
          class="text-14 fw-400"
          [innerHTML]="'users.authenticator.setup.steps.' + i | translate"
        ></li>
      }
    </ul>

    <div class="qr-wrapper mt-12 mb-12">
      <canvas #qrCanvas></canvas>
    </div>

    <div class="setup-key">
      <div class="setup-key-label text-14 fw-400 color-gray-800 text-align-center">
        {{ 'users.authenticator.setup.setup-key' | translate }}
      </div>

      <p-icon-field class="setup-key-input">
        <input
          class="text-14 fw-400 h--40"
          pInputText
          [readonly]="true"
          [value]="currentMfaSecret() || ''"
        />

        <p-inputicon>
          <app-icon-copy-outlined-1
            class="clickable"
            [width]="20"
            [height]="20"
            [color]="'var(--color-gray-500)'"
            (click)="copySetupKey()"
          >
          </app-icon-copy-outlined-1>
        </p-inputicon>
      </p-icon-field>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer w100 justify-space-between">
      <p-button
        class="text-14 fw-600 h--40 w50"
        [disabled]="cancelDisabled()"
        [severity]="'secondary'"
        (click)="close()"
      >
        {{ 'button.cancel' | translate }}
      </p-button>

      <p-button class="text-14 fw-600 h--40 w50" (click)="authenticatorCodeDialogRef.open()">
        {{ 'common.next' | translate }}
      </p-button>
    </div>
  </ng-template>
</p-dialog>

<app-authenticator-code-dialog
  #authenticatorCodeDialogRef
  [mode]="'setup'"
  (confirmed)="close()"
></app-authenticator-code-dialog>
